export const BREAKDOWNS = ['hours', 'days', 'weeks', 'months'];
